/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.n
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  homologacao: false,

  // URL of development API

  //LocalHost
  // apiUrl: 'http://localhost:53768/v1'

  //Aceite
  //  apiUrl: 'https://renosoft.com.br/apiteste/v1'


  //Produçao - RenoSoft
    apiUrl: 'https://renosoft.com.br/api/v1'

  ,

  login: 'renodesenv@gmail.com',
  password: '@DevReno#2022',
  timeOut: 80
};
